import { Component, ElementRef, Input, Output, Renderer2, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ControlContainer, Form, FormGroup, FormGroupDirective } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SpinnerComponent } from '../spinner/spinner.component';
import {  BehaviorSubject, Subscription } from 'rxjs';

import { SpinnerService } from '../spinner.service';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';

import { ActionBarStatus } from '@app/shared/_models/common';


@Component({
    selector: 'app-action-bar',
    templateUrl: './action-bar.component.html',
    styleUrls: ['./action-bar.component.scss'],
    imports: [MatButtonModule, MatTooltipModule, MatIconModule],
		changeDetection: ChangeDetectionStrategy.Eager,
		standalone: true,
})
export class ActionBarComponent {
	@Input() public form: string = "";						// Name of form to submit (OBSOLETE)
	@Input() public hassave: boolean = true;			// Save button?
	@Input() public canSave: boolean = true;			// unable save
	@Input() public saveTooltip: string = "";		// Motif du grisage d'« Enregistrer » ; vide = pas d'infobulle
	@Input() public hasback: boolean = false;			// Back button?

	@Input() public actionBarState$  : BehaviorSubject<ActionBarStatus> =new BehaviorSubject<ActionBarStatus>(new ActionBarStatus(true,true));			// Back button?
	// private saveStatusButtonSubject : BehaviorSubject<number> = new BehaviorSubject<number>(0);
	
	@Output() submitEmitter = new EventEmitter<string>();	// Emits the form name (utility?)

	public isSaveButtonValidable!: boolean;
	private actionBarStateSubscription!: Subscription;

	// @Output() saveState = new B<String>();	// Emits the form name (utility?)

	constructor(private spinner: SpinnerService) { }

	ngOnInit(): void {
		// this.actionBarStateSubscription = this.actionBarState$!.subscribe(obj => this.isSaveButtonValidable =  obj.saveStatus )
	 }

	 public onSubmit(e: Event) {
		 console.log("ActionBarComponent - onSubmit, form: " + this.form)
		 e.stopPropagation();
		 this.submitEmitter.emit(this.form);
		}
		
		public onCancel() {
			console.log("Cancel");
			this.spinner.show();
		}
	}
		
